import { NumericalColumn, StringColumn } from 'baseui/data-table';

export const COL_NAMES = {
	zupeeuserid: 'zupeeuserid',
	playingtableid: 'playingtableid',
	collusion: 'collusion'
};

export const columnConfigs = [
	NumericalColumn({
		title: 'Zupee User ID',
		mapDataToValue: (data: any) => data[COL_NAMES.zupeeuserid]
	}),
	StringColumn({
		title: 'Playing Table ID',
		mapDataToValue: (data: any) => data[COL_NAMES.playingtableid] || ''
	}),
	StringColumn({
		title: 'Result',
		mapDataToValue: (data: any) => (data[COL_NAMES.collusion] === '0' ? 'Collusion did not happen.' : 'Collusion happend.')
	})
];
